<div class="section secion-blog cd-section" id="blogs">

<!--     *********     BLOGS 1      *********      -->
    <div class="blog-1" id="blog-1">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h2 class="title">Latest Blogposts</h2>
                    <br />
                    <div class="card card-plain card-blog">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="card-image">
                                    <img class="img" src="assets/img/sections/stephanie-krist.jpg" />
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h6 class="card-category text-info">Enterprise</h6>
                                    <h3 class="card-title">
                                        <a href="javascript:void(0)">The four waves of augmented reality</a>
                                    </h3>
                                    <p class="card-description">
                                        Sharing processing, display and sensors across smartphones and tethered smartglasses gives you two batteries, each powering fewer individual systems. If they’re connected by a cable, this could give a healthy bump to battery life — and… <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>Tim Merel</b></a>, 11 hours ago
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="card card-plain card-blog">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="card-body">
                                    <h6 class="card-category text-danger">
                                        <i class="fa fa-free-code-camp" aria-hidden="true"></i> Trending
                                    </h6>
                                    <h3 class="card-title">
                                        <a href="javascript:void(0)">Okoli connects you with tour guides around the world</a>
                                    </h3>
                                    <p class="card-description">
                                        Okoli is a new service by developer Jack Deneut that aims to replace those ugly little cards you find in tourist hotels. The web app, which currently works in Prague, Budapest, Berlin and Paris, lets you reserve a nearly private tour with a professional guid — and… <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>John Biggs</b></a>, 3 seconds ago
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="card-image">
                                    <img class="img" src="assets/img/sections/federico-beccari.jpg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

<!--     *********     BLOGS 2      *********      -->

    <div class="blog-2 section section-gray">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h2 class="title">Latest Blogposts 2</h2>
                    <br />
                    <div class="row">
                        <div class="col-md-4">
                            <div class="card card-blog">
                                <div class="card-image">
                                    <a href="javascript:void(0)">
                                        <img class="img img-raised" src="assets/img/sections/miguel-perales.jpg" />
                                    </a>
                                </div>
                                <div class="card-body">
                                    <h6 class="card-category text-info">Enterprise</h6>
                                    <h5 class="card-title">
                                        <a href="javascript:void(0)">LinkedIn’s new desktop app arrives</a>
                                    </h5>
                                    <p class="card-description">
                                        LinkedIn is today launching its official desktop application for Windows 10, allowing the professional social networking service to... <br/>
                                    </p>
                                    <hr>
                                    <div class="card-footer">
                                        <div class="author">
                                            <a href="javascript:void(0)">
                                               <img src="assets/img/faces/ayo-ogunseinde-2.jpg" alt="..." class="avatar img-raised">
                                               <span>Mike John</span>
                                            </a>
                                        </div>
                                        <div class="stats">
                                            <i class="fa fa-clock-o" aria-hidden="true"></i> 5 min read
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="card card-blog">
                                <div class="card-image">
                                    <a href="javascript:void(0)">
                                        <img class="img img-raised" src="assets/img/sections/roger-keller.jpg" />
                                    </a>
                                </div>
                                <div class="card-body">
                                    <h6 class="card-category text-success">
                                        Startups
                                    </h6>
                                    <h5 class="card-title">
                                        <a href="javascript:void(0)">MIT’s Cheetah 3 robot is built to save lives</a>
                                    </h5>
                                    <p class="card-description">
                                        The latest version of MIT’s Cheetah robot made its stage debut today at TC Sessions: Robotics in Cambridge, Mass. It’s a familiar project... <br/>
                                    </p>
                                    <hr>
                                    <div class="card-footer">
                                        <div class="author">
                                            <a href="javascript:void(0)">
                                               <img src="assets/img/faces/kaci-baum-2.jpg" alt="..." class="avatar img-raised">
                                               <span>Nickie Kelly</span>
                                            </a>
                                        </div>
                                        <div class="stats">
                                            <i class="fa fa-clock-o" aria-hidden="true"></i> 5 min read
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="card card-blog">
                                <div class="card-image">
                                    <a href="javascript:void(0)">
                                        <img class="img img-raised" src="assets/img/sections/joshua-earlesz.jpg" />
                                    </a>
                                </div>

                                <div class="card-body">
                                    <h6 class="card-category text-danger">
                                        <i class="fa fa-free-code-camp" aria-hidden="true"></i> Enterprise
                                    </h6>
                                    <h5 class="card-title">
                                        <a href="javascript:void(0)">Lionel Richie says “Hello” to startup investors</a>
                                    </h5>
                                    <p class="card-description">
                                        Because developing a doctor-on-demand service that would allow personalized medical visits, booked through an app on a user’s phone is... <br/>
                                    </p>
                                    <hr>
                                    <div class="card-footer">
                                        <div class="author">
                                            <a href="javascript:void(0)">
                                               <img src="assets/img/faces/erik-lucatero-2.jpg" alt="..." class="avatar img-raised">
                                               <span>Mike John</span>
                                            </a>
                                        </div>
                                        <div class="stats">
                                            <i class="fa fa-clock-o" aria-hidden="true"></i> 5 min read
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


<!--     *********     BLOGS 3      *********      -->
    <div class="blog-3">
        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <h2 class="title">Latest Blogposts 3</h2>
                    <br />
                    <div class="card card-plain card-blog">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card-image">
                                    <img class="img" src="assets/img/sections/jeff-sheldon.jpg" />
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h6 class="card-category text-info">Enterprise</h6>
                                    <h3 class="card-title">
                                        <a href="javascript:void(0)">SoundCloud says it’s going to survive, but how?</a>
                                    </h3>
                                    <p class="card-description">
                                        No matter what happens — funding versus acquisition versus who knows what — Ljung says SoundCloud is not going away “anytime in the foreseeable future.” I hope that’s true, but I can’t help but feel a bit skeptical. — and… <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>Megan Rose Dickey</b></a>, 11 days ago
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card card-plain card-blog">
                        <div class="row">
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h6 class="card-category text-danger">
                                        <i class="fa fa-free-code-camp" aria-hidden="true"></i> Trending
                                    </h6>
                                    <h3 class="card-title">
                                        <a href="javascript:void(0)">Uber acqui-hires social app studio Swipe Labs</a>
                                    </h3>
                                    <p class="card-description">
                                        These issues might be making it a bit harder for Uber to hire right now in the competitive Silicon Valley job market. Acqui-hiring companies like it’s doing here with Swipe Labs lets it roll up a bunch of good talent — and… <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>Josh Constine</b></a>, 2 days ago
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="card-image">
                                    <a href="javascript:void(0)">
                                        <img class="img" src="assets/img/sections/rawpixel-comm.jpg" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card card-plain card-blog">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="card-image">
                                    <a href="javascript:void(0)">
                                        <img class="img" src="assets/img/sections/jeremy-yap.jpg" />
                                    </a>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                    <h6 class="card-category text-success">
                                        Startups
                                    </h6>
                                    <h3 class="card-title">
                                        <a href="javascript:void(0)">HBO and Netflix lead this year’s nominations</a>
                                    </h3>
                                    <p class="card-description">
                                        Streaming services once again top the list of this year’s Emmy nominations – another indicator of the shift in how today’s consumers are watching TV. HBO, which has been available. <a href="javascript:void(0)"> Read More </a>
                                    </p>
                                    <p class="author">
                                        by <a href="javascript:void(0)"><b>Sarah Perez</b></a>, 14 Jul 2017
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


<!--     *********     BLOGS 4      *********      -->
    <div class="blog-4">
        <div class="container">
            <div class="row">
                <div class="col-md-8 ml-auto mr-auto">
                    <h2 class="title text-center">Latest Blogposts 4</h2>
                    <br />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card card-plain card-blog text-center">
                        <div class="card-image">
                            <a href="javascript:void(0)">
                                <img class="img img-raised" src="assets/img/sections/val-vesa.jpg" />
                            </a>
                        </div>
                        <div class="card-body">
                            <h6 class="card-category text-warning">Travel</h6>
                            <h3 class="card-title">
                                <a href="javascript:void(0)">Learning different cultures through travel</a>
                            </h3>
                            <p class="card-description">
                                A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence in this spot.
                            </p>
                            <br/>
                            <a href="javascript:void(0)" class="btn btn-warning btn-round"> Read More</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-plain card-blog text-center">
                        <div class="card-image">
                            <a href="javascript:void(0)">
                                <img class="img img-raised" src="assets/img/sections/rodrigo-ardilha.jpg" />
                            </a>
                        </div>
                        <div class="card-body">
                            <h6 class="card-category text-info">Travel</h6>
                            <h3 class="card-title">
                                <a href="javascript:void(0)">Kick-Ass ways to disappear like a Ninja!</a>
                            </h3>
                            <p class="card-description">
                                In the end, the judge ruled that Levandowski could be brought in and examined, but that each question asked to him would be vetted in advance and should have some basis in evidence.
                            </p>
                            <br/>
                            <a href="javascript:void(0)" class="btn btn-primary btn-round"> Read More</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="card card-plain card-blog text-center">
                        <div class="card-image">
                            <a href="javascript:void(0)">
                                <img class="img img-raised" src="assets/img/sections/federico-beccari.jpg" />
                            </a>
                        </div>
                        <div class="card-body">
                            <h6 class="card-category text-danger">Lifestyle</h6>
                            <h3 class="card-title">
                                <a href="javascript:void(0)">We will breathe clean air and exercise</a>
                            </h3>
                            <p class="card-description">
                                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is too high for the beams and angle of the ceiling...
                            </p>
                            <br/>
                            <a href="javascript:void(0)" class="btn btn-danger btn-round"> Read More</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card card-plain card-blog text-center">
                        <div class="card-image">
                            <a href="javascript:void(0)">
                                <img class="img img-raised" src="assets/img/sections/pedro-lastra.jpg" />
                            </a>
                        </div>
                        <div class="card-body">
                            <h6 class="card-category text-success">Best Seller</h6>
                            <h3 class="card-title">
                                <a href="javascript:void(0)">Readers Pick of The Month</a>
                            </h3>
                            <p class="card-description">
                                “Raising equity is very expensive” In essence, it lets new consumer businesses apply to raise funding on its platform, and gives investors a new way to find and back those tricks to finance their growing businesses.
                            </p>
                            <br/>
                            <a href="javascript:void(0)" class="btn btn-success btn-round"> Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!--     *********     BLOGS 4      *********      -->

    <div class="blog-5">
        <div class="container">
            <h2 class="title text-center">Your Latest Blogpost 5</h2>
            <div class="row">
                <div class="col-md-7">
                    <div class="card" data-background="image" style="background-image: url('assets/img/sections/uriel-soberanes.jpg')">
                        <div class="card-body">
                            <h6 class="card-category">
                                <i class="fa fa-newspaper-o"></i> Lifestyle</h6>
                            <a href="javascript:void(0)">
                                <h3 class="card-title">Twenty-Something Travel - Virtual Wayfarer</h3>
                            </a>
                            <p class="card-description">
                                As happens in most of these hearings so far, that argument led to a back-and-forth between Uber and Waymo’s lawyers over the pre-trial discovery...
                            </p>
                            <div class="card-footer">
                                <div class="author">
                                    <a href="javascript:void(0)">
                                       <img src="assets/img/faces/joe-gardner-2.jpg" alt="..." class="avatar img-raised">
                                       <span>Lynne Barrett</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="card" data-background="image" style="background-image: url('assets/img/sections/forest-bg.jpg')">
                        <div class="card-body">
                            <h6 class="card-category">
                                <i class="fa fa-newspaper-o"></i> Media</h6>
                            <a href="javascript:void(0)">
                                <h3 class="card-title">The aesthetic quality of a product</h3>
                            </a>
                            <p class="card-description">
                                 It clarifies the product’s structure. Better still, it can make the product clearly express its function by making use of the user’s intuition.
                            </p>
                            <div class="card-footer">
                                <div class="author">
                                    <a href="javascript:void(0)">
                                       <img src="assets/img/faces/erik-lucatero-2.jpg" alt="..." class="avatar img-raised">
                                       <span>Eric J Barnes</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="card" data-background="image" style="background-image: url('assets/img/sections/pavel-kosov.jpg')">
                        <div class="card-body">
                            <h6 class="card-category">
                                <i class="fa fa-newspaper-o"></i>Design</h6>
                            <a href="javascript:void(0)">
                                <h3 class="card-title">“Good Design”</h3>
                            </a>
                            <p class="card-description">
                                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Jay-z...
                            </p>
                            <div class="card-footer">
                                <div class="author">
                                    <a href="javascript:void(0)">
                                       <img src="assets/img/faces/kaci-baum-2.jpg" alt="..." class="avatar img-raised">
                                       <span>Patricia Beatty</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card" data-background="image" style="background-image: url('assets/img/sections/ilya-yakover.jpg')">
                        <div class="card-body">
                            <h6 class="card-category">
                                <i class="fa fa-newspaper-o"></i> Development</h6>
                            <a href="javascript:void(0)">
                                <h3 class="card-title">In need of a good development</h3>
                            </a>
                            <p class="card-description">
                                Speed up your development time or get inspired with the large number of example pages. You can jump start your development with our pre-built example pages.
                            </p>
                            <div class="card-footer">
                                <div class="author">
                                    <a href="javascript:void(0)">
                                       <img src="assets/img/faces/clem-onojeghuo-3.jpg" alt="..." class="avatar img-raised">
                                       <span>Robert Brandon</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card" data-background="image" style="background-image: url('assets/img/sections/vincent-versluis.jpg')">
                        <div class="card-body">
                            <h6 class="card-category">
                                <i class="fa fa-newspaper-o"></i> Technology</h6>
                            <a href="javascript:void(0)">
                                <h3 class="card-title">A Little Adrift</h3>
                            </a>
                            <p class="card-description">
                                But from the perspective of founders, there’s bound to be some confusion. In an ideal world we will see a meeting of the minds
                            </p>
                            <div class="card-footer">
                                <div class="author">
                                    <a href="javascript:void(0)">
                                       <img src="assets/img/faces/ayo-ogunseinde-2.jpg" alt="..." class="avatar img-raised">
                                       <span>Ayo Michael</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
